import md5 from 'blueimp-md5';
import * as A from 'fp-ts/Array';
import * as Ord from 'fp-ts/Ord';
import { Ord as ordString } from 'fp-ts/string';

interface VoteLike {
  id: string;
  comment?: string | null;
}

const byHashedContent = Ord.contramap((v: VoteLike) =>
  md5(`${v.id}${v.comment || ''}`),
)(ordString);

/**
 * Sorts a list of votes by the md5 hash of the ID and comment.
 * This provides deterministic shuffling of the votes which makes
 * it harder to guess who cast which vote as they'll no longer be
 * in chronological order.
 */
export const shuffleVotes = A.sort(byHashedContent);
